import "./App.css";
import { Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./components/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import Speakhabla from "./components/Speakhabla/Speakhabla";
import Fitfun from "./components/Fitfun/Fitfun";
import Grocery from "./components/Grocery/Grocery";
import Projects from "./components/Projects/Projects";
import Intellikid from "./components/Intellikid/Intellikid";
import Footer from "./components/Footer/Footer";
import Contact from "./components/Contact/Contact";

function App() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 10) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  // This function will scroll the window to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smoothly scrolling
    });
  };

  return (
    <div className="App">
      <>
        <Navbar />
        <Routes>
          <Route path="/Portfolio/" exact element={<Home />} />
          <Route path="/Portfolio/fitfun" exact element={<Fitfun />} />
          <Route path="/Portfolio/intellikid" exact element={<Intellikid />} />
          <Route path="/Portfolio/speakhabla" element={<Speakhabla />} />
          <Route
            path="/Portfolio/loblaw-grocery-selfcheckout"
            element={<Grocery />}
          />
          <Route path="/Portfolio/projects" element={<Projects />} />
          <Route path="/Portfolio/contacts" element={<Contact />} />
        </Routes>
        <Footer />
        {showButton && (
          <button onClick={scrollToTop} className="back-to-top">
            &#8679;
          </button>
        )}
        {/* &#8679; is used to create the upward arrow */}
      </>
    </div>
  );
}

export default App;
